import React, { useState, useEffect } from 'react';

import '../assets/css/ListItem.scss';
import history from '../history';

const ListItem = ({width, image, title, category, comune, regionName, obj}) => {
  const [pyme, setPyme] = useState(null);

  useEffect(() => {
    setPyme(obj._source);
  }, [obj._source]);

  const splitCategories = (categories) => {
    let category = '';
    category = categories.map((category, index) => {
      return (index === 0) ? category : ''
    })
    return category;
    //return categories.split(',')[0];
  };

  const displayPymeInfo = (pyme) => {
    console.log(pyme)
    let rut = clearRut(pyme.rutPyme);
    history.push('/pyme/details/'+rut, pyme);
  };

  const clearRut = (rut) => {
    console.log(rut)
    return rut.replace(/[^A-Za-z0-9]+/gi, "").toUpperCase();
  };

  return (
    <div className={"col-lg-"+width} onClick={() => displayPymeInfo(pyme)}>
      <div className="item-list">
        <div className="row" style={{ padding: '1%' }}>
          <div className="col-4 col-md-2">
            {
              image!==null && typeof image !=="undefined" ?
              <div className="img-box">
                <img className="img-square" src={image} alt="company"/>
              </div>
              :
              <div className="img-box">
                <img className="img-square" src={"/img/default-img.svg"} alt="company"/>
              </div>
            }
          </div>

          <div className="col-8 col-md-4">
            <div className="item-box-description">
              {title}
            </div>
          </div>

          <div className="col-12 col-md-3">
            <div className="item-list-data t-p-10">
              <span className="category-txt-box">{category!==null && category!=="" && typeof category!=="undefined" ? splitCategories(category) : 'N/A'}</span>
            </div>
          </div>

          <div className="col-12 col-md-3">
            <div className="item-list-data t-p-10">
              <strong>{comune}{regionName}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListItem;
